/**
 * Transitional: the PHP API answers { key: value }, the Go API answers just the value (ApiClient has
 * already taken it out of the envelope). An endpoint function reads both through this until PHP is gone;
 * then it reads the Go shape directly and this file is deleted.
 */
export const fromEither = <T>(body: unknown, phpKey: string): T => {
    if (typeof body === "object" && body !== null && !Array.isArray(body) && phpKey in body) {
        return (body as Record<string, unknown>)[phpKey] as T;
    }
    return body as T;
};
